import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const messageStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    right: 40,
    color: '#ffffff',
    zIndex: 1000,
    textAlign: 'left',
    width: '50%',
    height: 'calc( 50% - 68px )',
    paddingLeft: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      top: '20%',
      fontSize: '0.8em',
      height: 'calc( 80% - 68px )',
    },
    '& li': {
      color: '#fff',
      listStyleType: 'none',
      textAlign: 'right',
      animation: '$fadeout 1s 1 ease-in-out ',
      animationDelay: '30s',
      animationFillMode:'forwards',
      marginBottom: 5,
      textShadow: '1px 1px 1px rgba(4, 4, 4, 1)',
    }
  },
  '@keyframes fadeout': {
    '0%': {
      transform: 'scale(1.0)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(1.1)',
      opacity: 0,
    },
  },
}));

export default function OverlayMessages(props) {
  const classes = messageStyles(props);
  return (<ul className={classes.root}>{props.messages.map( (msg,idx) => (
    <li key={idx}>{msg.message.from ? `${msg.message.from}: ${msg.message.text}` : msg.message.text }</li>
    ))}</ul>);
}
